
import React from 'react';

export const FeaturedProducts: React.FC = () => {
  const products = [
    {
      id: 1,
      name: 'Premium Cotton T-Shirt',
      price: 29.99,
      originalPrice: 39.99,
      image: 'https://public.readdy.ai/ai/img_res/6328e03823f842ab75d492c0c124a472.jpg',
      rating: 4.8,
      reviews: 124,
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Elegant Gold Necklace',
      price: 89.99,
      originalPrice: 120.00,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20gold%20necklace%20jewelry%20on%20clean%20white%20background%2C%20luxury%20accessories%2C%20sparkling%20gold%20chain%2C%20professional%20jewelry%20photography%2C%20soft%20lighting%2C%20minimalist%20composition%2C%20centered%20layout&width=200&height=200&seq=prod2&orientation=squarish',
      rating: 4.9,
      reviews: 89,
      badge: 'New'
    },
    {
      id: 3,
      name: 'Comfortable Running Shoes',
      price: 79.99,
      originalPrice: 99.99,
      image: 'https://readdy.ai/api/search-image?query=Modern%20running%20shoes%20sneakers%20on%20clean%20white%20background%2C%20athletic%20footwear%2C%20comfortable%20sports%20shoes%2C%20professional%20product%20photography%2C%20soft%20lighting%2C%20minimalist%20composition%2C%20centered%20layout&width=200&height=200&seq=prod3&orientation=squarish',
      rating: 4.7,
      reviews: 203,
      badge: 'Sale'
    },
    {
      id: 4,
      name: 'Ceramic Coffee Mug Set',
      price: 24.99,
      originalPrice: 34.99,
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20coffee%20mug%20set%20on%20clean%20white%20background%2C%20household%20items%2C%20kitchen%20accessories%2C%20elegant%20tableware%2C%20professional%20product%20photography%2C%20soft%20lighting%2C%20minimalist%20composition%2C%20centered%20layout&width=200&height=200&seq=prod4&orientation=squarish',
      rating: 4.6,
      reviews: 156,
      badge: 'Popular'
    }
  ];

  return (
    <section className="px-4 mb-6" data-product-shop>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">Featured Products</h2>
        <button className="text-emerald-500 text-sm font-medium">View All</button>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-50 hover:shadow-md transition-shadow"
          >
            {/* Product Image */}
            <div className="relative">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-40 object-cover object-top"
              />
              {product.badge && (
                <span className="absolute top-2 left-2 bg-emerald-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  {product.badge}
                </span>
              )}
              <button className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors">
                <i className="ri-heart-line text-gray-600 text-sm"></i>
              </button>
            </div>
            
            {/* Product Info */}
            <div className="p-3">
              <h3 className="font-semibold text-gray-800 text-sm mb-1 line-clamp-2">
                {product.name}
              </h3>
              
              {/* Rating */}
              <div className="flex items-center mb-2">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-yellow-400 text-xs`}
                    ></i>
                  ))}
                </div>
                <span className="text-xs text-gray-500 ml-1">({product.reviews})</span>
              </div>
              
              {/* Price */}
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1">
                  <span className="font-bold text-emerald-600">${product.price}</span>
                  <span className="text-xs text-gray-400 line-through">${product.originalPrice}</span>
                </div>
                <button className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                  <i className="ri-add-line text-white text-sm"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
